import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	data: [],
	isLoaded: false,
	isError: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ******************* Fetch user payments *******************
			case types.USER_PAYMENTS_LOADING:
				return INITIAL_STATE;

			case types.USER_PAYMENTS_SUCCESS:
				draft.isLoaded = true;
				draft.data = action.payload;
				return;

			case types.USER_PAYMENTS_ERROR:
				draft.isError = true;
				return;

			default:
				return state;
		}
	});
